// src/components/GetUserAvatar.tsx
import React, { useState, useEffect } from 'react';
import { Avatar } from '@progress/kendo-react-layout';
import axios from 'axios';
import config from '../config/config';
import { useAuth } from '../contexts/AuthContext';
import ProfilePicture from '../images/exploserv_profile_placeholder.png'; // Pfad zum Logo importieren

const GetUserAvatar: React.FC = () => {
  const { userId } = useAuth();
  // Fallback: statisches Demo-Bild
  const [avatarUrl, setAvatarUrl] = useState<string>(ProfilePicture);

  useEffect(() => {
    if (!userId) return;

    const fetchUserAvatar = async () => {
      try {
        const response = await axios.get(`${config.host}/user/me`, {
          headers: { 'Authorization': `Bearer ${userId}` }
        });
        const userData = response.data;
        if (userData && userData.avatar_url) {
          let url = userData.avatar_url;
          // Nur in der Produktion die URL-Anpassungen vornehmen
          if (config.production === "true") {
            // Stelle sicher, dass HTTPS verwendet wird
            url = url.replace(/^http:\/\//, 'https://');
            // Falls nicht bereits vorhanden, füge "/api" nach der Domain ein
            url = url.replace(/(https:\/\/[^\/]+)(\/get_image\/)/, '$1/api$2');
          }
          setAvatarUrl(url);
        }
      } catch (error) {
        console.error('❌ Fehler beim Abrufen des Benutzeravatars:', error);
      }
    };

    fetchUserAvatar();
  }, [userId]);

  return (
    <Avatar type="image">
      <img src={avatarUrl} alt="Benutzer Avatar" />
    </Avatar>
  );
};

export default GetUserAvatar;
